import request from "../../src/utils/request"
// 测试学校简介

/**
 * @param contentMenu 内容所属栏目 菜单ID
 * @param pageNum: 页码
 * @param pageSize: 一个条数
 * **/

export function contentList(data) {
    data.status = 0
    return request({
        url: '/system/general-content/list',
        method: 'post',
        data,
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    });
}

// 菜单
export function listWeb(data) {
    if (data) data.visible = 0
    else data = {
        visible: 0
    }
    return request({
        url: '/system/web/listWeb',
        method: 'post',
        data,
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    });
}
// 根据文章Id查询
export function listInfo(data) {
    return request({
        url: '/system/general-content/info',
        method: 'get',
        params:data,
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    });
}

// 关于我们
export function postAboutOurs(data) {
    data.status = 0
    return request({
        url: '/system/video/list',
        params: data,
        method: 'POST'
    })
}


//////////////////
// WEBPACK FOOTER
// ./api/home/home.js
// module id = OlOQ
// module chunks = 13